var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ChatThread', {
    attrs: {
      "has-next-page": _vm.isMessagesLoaded && !!_vm.nextPage,
      "messages": _vm.messages,
      "date-resolver": e => e.sentat * 1000
    },
    on: {
      "next-page": _vm.messageScroll
    },
    scopedSlots: _vm._u([{
      key: "bubble",
      fn: function ({
        message
      }) {
        return [_c('DoctorPatientChatBubble', {
          attrs: {
            "entry": message,
            "sender-name": _vm.getSenderName(message)
          }
        })];
      }
    }])
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };